import React, { useEffect, useState, useRef } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Button,
  Radio,
  Checkbox,
  Popover,
  Spin,
  Tooltip,
  Modal,
  Typography,
  Col,
  Row,
  Divider,
} from 'antd';
import {
  InfoCircleFilled,
  LoadingOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  CopyOutlined,
} from '@ant-design/icons';

import cx from 'classnames';
import styles from './queryBuilder.module.sass';
import mixpanel from 'mixpanel-browser';
import history from '../../../../redux/history';
import { STATUS } from '../../../../redux/constants';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import Cookies from 'cookies-js';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import Monitor from '../../../../shared-components/Monitor';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import { default as threat_detail_styles } from '../../../HomeContainer/components/Home/threat-detail.module.sass';
import RecipeDocumentation from '../../../../shared-components/RecipeDocumentation';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { JSONViewer } from '../../../../shared-components/JSONViewer';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';

function QueryBuilder(props) {
  mixpanel.track('Global Nav - Query Builder', {
    location: window.location.href,
  });

  const {
    status,
    exploreAPIscoreDetails: exploreData,
    mergeAPIData: mergeData,
  } = props;

  const [form] = Form.useForm();

  const PrettyPrintJson = React.memo(({ data }) => <JSONViewer data={data} />);

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  let q = useQuery();

  const dispatch = useDispatch();
  const [nameOfNewQuery, setNameOfNewQuery] = useState('');
  const [descriptionOfNewQuery, setDescriptionOfNewQuery] = useState('');
  const [selectedSchemaUUID, setSelectedSchemaUUID] = useState(null);
  const [selectedSchema, setSelectedSchema] = useState(null);
  //const [selectedSchemaName, setSelectedSchemaName] = useState(null);
  const [baseURLType, setBaseURLType] = useState(null);
  const [queryBuilderURL, setQueryBuilderURL] = useState(null);
  const [queryBuilderStateFilter, setQueryBuilderStateFilter] = useState(
    q?.get('state') === 'advanced' ? 'advanced' : 'simple',
  );
  const [dataSource, setDataSource] = useState(null);
  const [isPostForm, setIsPostForm] = useState(false);
  const [fieldNames, setFieldNames] = useState([]);
  const [isVisualizable, setIsVisualizable] = useState(false);
  const [isJobIDButtonToBeShown, setIsJobIDButtonToBeShown] = useState(false);
  const [visualizationType, setVisualizationType] = useState(null);
  const [visualizationName, setVisualizationName] = useState(null);
  const [jobID, setJobID] = useState(null);
  const [monitorModalVisible, setMonitorModalVisible] = useState(false);
  const [monitorName, setMonitorName] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [
    advancedQueryButtonDisabled,
    setAdvancedQueryButtonDisabled,
  ] = useState(true);
  const resetPressed = useRef(false);

  const { Title, Paragraph, Text } = Typography;
  let doubleHeightElements = [];
  let statusLoaded = props?.schemaStatus === STATUS.LOADED ? true : false;
  let statusIdle = props?.schemaStatus === STATUS.IDLE ? true : false;

  const filterButtonChecked = {
    background: 'rgba(60, 154, 232, 0.48)',
    borderRadius: '4px',
    border: '0',
    marginRight: 8,
  };

  const filterButtonUnchecked = {
    ...filterButtonChecked,
    background: 'rgba(255, 255, 255, 0.08)',
  };

  const listOfUUIDsToVisualize = [
    '8d1aa841-bfa1-4160-a809-9d1063c8a0ef', //Domain search
    '19eabdf7-eeeb-43e8-b110-8fd96fe2fbdb', //Domain name server changes
    '71564dfd-d52a-4cf1-aab4-c7483af04ff6', //PADNS IP Diversity lookup
    'a426b767-3999-4419-aadc-bf510b3914cb', //PADNS Live Unsanctioned Assets lookup
    '370338a9-7485-40ef-9a43-508236e2306b', //PADNS forward lookup
    '60226683-52ed-4c6b-9f26-41f2918e76c0', //PADNS multi-condition lookup
    'ed2b8d10-23a1-4034-8f16-40331df5c56f', //PADNS reverse lookup
    '40710e97-441d-4505-9902-a3a756072f71', //Xperimental - autospoofing, advanced
    '14a1e710-d31d-4d5e-ab4a-e1503e6987ce', //Xperimental - autospoofing, simple
    'ed35069b-850b-4c1d-ba07-d690611c3947', //PADNS search ipdiversity patterns
    '031888f5-6a64-4e8b-8d98-ad2dce764e56', //???
    '01ddd140-ea77-4f68-b468-019876a2ce25', //???
    '0c796b77-5808-4892-beda-d1d5856bdb73', //???
    '8b10c9da-3980-40c4-8db5-96dc36d74c72', //Xperimental - PADNS domain snapshot
    'a55cf850-212f-457f-bcb6-e54ddf7ecce5', //PADNS search SOA records
    '5e9b2b89-b94b-4d34-87ba-1f3ef9b4b132', //Xperimental - ssdeep get scandata
    'a8af0d0e-b879-4fb7-a4b4-2c57d33e03d3', //Xperimental - PADNS wildcard records
  ];

  const titleText = q?.get('left_menu_name') ?? selectedSchema?.name;

  function cleanup() {
    setBaseURLType(null);
    setQueryBuilderURL(null);
    setDataSource(null);
    setIsVisualizable(false);
    setVisualizationType(null);
    setVisualizationName(null);
    q?.get('jobid') ? setJobID(q?.get('jobid')) : setJobID(null);
    setIsJobIDButtonToBeShown(false);
    setNameOfNewQuery('');
    setDescriptionOfNewQuery('');
  }

  function resetForm() {
    Cookies.expire(selectedSchemaUUID);
    form.resetFields();
    cleanup();
    resetPressed.current = true;
    if (q?.get('query')) {
      loadDataOnlyOnce(q?.get('query'));
    }
  }

  useEffect(() => {
    q = new URLSearchParams(window.location.search);
    cleanup();
    props.clearExploreDetails();
    setFieldNames([]);
    setIsPostForm(false);
    props.loadUser();
    props.loadMySubscriptionPlan();
    props.loadMergeAPIExploreQueryBuilderSchemas();

    form.resetFields();
  }, [props.location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    cleanup();
    setFieldNames([]);
    setIsPostForm(false);
    props.clearExploreDetails();
    q?.get('state') === 'advanced'
      ? setQueryBuilderStateFilter('advanced')
      : setQueryBuilderStateFilter('simple');

    if (props.exploreSchema) {
      setSelectedSchemaUUID(props.exploreSchema?.metadata?.form_uuid);
      setSelectedSchema(props.exploreSchema);

      //check if there is a field with type data_list, so we can use the POST endpoints for this form
      let tempArrayToHoldKeys = [];
      for (var key in props.exploreSchema?.field_list) {
        if (props.exploreSchema?.field_list[key]?.field_type === 'data_list') {
          setIsPostForm(true);
          tempArrayToHoldKeys = [
            ...tempArrayToHoldKeys,
            props.exploreSchema?.field_list[key]?.field_name,
          ];
        }
      }
      setFieldNames(tempArrayToHoldKeys);

      document.title = `${props.exploreSchema?.metadata?.form_name?.replace(
        '-',
        '',
      )} - Silent Push`;
      dispatch(changeTitle(props?.exploreSchema?.metadata?.form_name, null));
    }
  }, [props.exploreSchema]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (status === STATUS.LOADED) {
      setDataSource(baseURLType === 'merge' ? mergeData : exploreData);
    } else {
      setDataSource(null);
    }
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadDataOnlyOnce = async (queryUUID) => {
    return await props?.loadMergeAPIExploreQueryBuilderSchema(queryUUID);
  };

  useEffect(() => {
    q = new URLSearchParams(window.location.search);
    if (q?.get('query')) {
      loadDataOnlyOnce(q?.get('query'));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (q?.get('query')) {
      loadDataOnlyOnce(q?.get('query'));
    }
  }, [window.location.search]);

  useEffect(() => form.resetFields(), [props.exploreSchema]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsVisualizable(false);
    setVisualizationType(null);
    setVisualizationName(null);
    setIsJobIDButtonToBeShown(false);
    setJobID(null);
    if (exploreData) {
      if (
        selectedSchemaUUID === 'f9a9ac7c-f1a0-4c9b-871c-2fb424194827' ||
        selectedSchema?.metadata?.form_parent_uuid ===
          'f9a9ac7c-f1a0-4c9b-871c-2fb424194827'
      ) {
        setIsVisualizable(false);
      } else if (
        (listOfUUIDsToVisualize.includes(selectedSchemaUUID) ||
          listOfUUIDsToVisualize.includes(
            selectedSchema?.metadata?.form_parent_uuid,
          )) &&
        exploreData?.response?.records &&
        exploreData?.response?.records?.length > 0 &&
        exploreData?.response?.records?.[0]?.hasOwnProperty('timeline')
      ) {
        setIsVisualizable(true);
        setVisualizationType('A');
      } else if (
        (listOfUUIDsToVisualize.includes(selectedSchemaUUID) ||
          listOfUUIDsToVisualize.includes(
            selectedSchema?.metadata?.form_parent_uuid,
          )) &&
        exploreData?.response?.records?.length > 0 &&
        exploreData?.response?.records?.[0]?.hasOwnProperty('query') &&
        exploreData?.response?.records?.[0]?.hasOwnProperty('answer')
      ) {
        setIsVisualizable(true);
        setVisualizationType('any');
      } else if (
        (selectedSchemaUUID !== '8d1aa841-bfa1-4160-a809-9d1063c8a0ef' &&
          selectedSchema?.metadata?.form_parent_uuid !==
            '8d1aa841-bfa1-4160-a809-9d1063c8a0ef' &&
          exploreData?.response?.records?.length > 0 &&
          listOfUUIDsToVisualize.includes(selectedSchemaUUID) &&
          !exploreData?.response?.records?.[0]?.hasOwnProperty('count')) ||
        (selectedSchemaUUID !== '8d1aa841-bfa1-4160-a809-9d1063c8a0ef' &&
          selectedSchema?.metadata?.form_parent_uuid !==
            '8d1aa841-bfa1-4160-a809-9d1063c8a0ef' &&
          listOfUUIDsToVisualize.includes(
            selectedSchema?.metadata?.form_parent_uuid,
          ) &&
          exploreData?.response?.records?.[0]?.hasOwnProperty(
            'asn_diversity',
          ) &&
          exploreData?.response?.records?.[0]?.hasOwnProperty('host') &&
          exploreData?.response?.records?.[0]?.hasOwnProperty(
            'ip_diversity_all',
          ) &&
          exploreData?.response?.records?.[0]?.hasOwnProperty(
            'ip_diversity_groups',
          ))
      ) {
        setIsVisualizable(true);
        setVisualizationType('IPDiversity');
        setVisualizationName(exploreData?.response?.records?.[0]?.host);
      } else if (
        exploreData?.response?.nschanges?.nschanges &&
        exploreData?.response?.nschanges?.nschanges?.length > 0
      ) {
        setIsVisualizable(true);
        setVisualizationType('NSChanges');
      } else if (
        exploreData?.response?.ssdeep &&
        exploreData?.response?.ssdeep?.length > 0
      ) {
        setIsVisualizable(true);
        setVisualizationType('ssdeep');
      }
      if (exploreData?.response?.job_status?.job_id) {
        setJobID(exploreData?.response?.job_status?.job_id);
        setIsJobIDButtonToBeShown(true);
      }
    }

    if (mergeData) {
      if (mergeData?.response?.job_status?.job_id) {
        setJobID(mergeData?.response?.job_status?.job_id);
        setIsJobIDButtonToBeShown(true);
      }
    }
  }, [exploreData, mergeData]);

  useEffect(() => {
    const schemaList = props?.exploreSchema?.field_list;
    if (statusLoaded) {
      for (let i in schemaList) {
        if (!schemaList?.[i]?.field_hidden) {
          setAdvancedQueryButtonDisabled(true);
        } else {
          setAdvancedQueryButtonDisabled(false);
          break;
        }
      }
    }
  }, [props?.exploreSchema?.field_list]);

  function visualizeJSONInExplore() {
    let queryBuilderNameToPassForBreadCrumb = '';
    if (queryBuilderURL?.includes('/typosquat')) {
      queryBuilderNameToPassForBreadCrumb = decodeURIComponent(queryBuilderURL)
        ?.split('/')
        ?.reverse()[1];
    } else if (
      decodeURIComponent(queryBuilderURL)
        ?.toString()
        ?.includes('/domain/search')
    ) {
      const paramString = decodeURIComponent(queryBuilderURL)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      queryBuilderNameToPassForBreadCrumb = params.get('domain');
    } else if (
      decodeURIComponent(queryBuilderURL)?.toString()?.includes('autospoof')
    ) {
      const paramString = decodeURIComponent(queryBuilderURL)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      queryBuilderNameToPassForBreadCrumb = params.get('autospoof');
    } else {
      queryBuilderNameToPassForBreadCrumb = decodeURIComponent(queryBuilderURL)
        ?.split('/')
        ?.pop()
        ?.split('?')[0];
    }

    const paramString = decodeURIComponent(queryBuilderURL)?.split('?')[1];
    const params = new URLSearchParams(paramString);

    if (
      decodeURIComponent(queryBuilderURL)?.toString()?.includes('prefer=jobid')
    ) {
      params.delete('prefer');
    }

    let finalQueryBuilderURL =
      decodeURIComponent(queryBuilderURL)?.split('?')[0] +
      (params ? '?' + params : '');

    const formToURLParam = JSONtoURL();
    if (visualizationType === 'any') {
      history.push(
        `/explore-result?name=${
          //props?.exploreSchema?.metadata?.form_name
          queryBuilderNameToPassForBreadCrumb
        }&queryType=queryBuilderVisualization&type=${
          form?.getFieldValue('qtype')
            ? form?.getFieldValue('qtype') === 'ANY'
              ? 'any'
              : form?.getFieldValue('qtype')
            : 'queryBuilderVisualization' ?? 'queryBuilderVisualization'
        }&fromQueryBuilder=true&queryBuilderVisualization=true&visualizationType=${visualizationType}&baseURLType=${baseURLType}&backLink=${encodeURIComponent(
          window.location.pathname,
        )}${encodeURIComponent(
          window.location.search,
        )}&originalQueryURL=${encodeURIComponent(
          finalQueryBuilderURL,
        )}&queryFormEncoded=${formToURLParam}&origin_uid=${getQueryUID(
          props?.exploreSchema?.metadata,
        )}`,
      );
    } else if (visualizationType === 'A') {
      history.push(
        `/explore-result?name=${queryBuilderNameToPassForBreadCrumb}&queryType=queryBuilderVisualization&type=${'A'}&fromQueryBuilder=true&queryBuilderVisualization=true&visualizationType=${visualizationType}&baseURLType=${baseURLType}&backLink=${encodeURIComponent(
          window.location.pathname,
        )}${encodeURIComponent(
          window.location.search,
        )}&originalRecipe=${encodeURIComponent(
          selectedSchemaUUID,
        )}&originalQueryURL=${encodeURIComponent(
          finalQueryBuilderURL,
        )}&queryFormEncoded=${formToURLParam}&origin_uid=${getQueryUID(
          props?.exploreSchema?.metadata,
        )}`,
      );
    } else if (visualizationType === 'IPDiversity') {
      history.push(
        `/explore-result?name=${visualizationName
          ?.toString()
          ?.replace('[', '')
          ?.replace(']', '')
          ?.trim()}&queryType=ipdiversity&backLink=${encodeURIComponent(
          window.location.pathname,
        )}${encodeURIComponent(
          window.location.search,
        )}&queryFormEncoded=${formToURLParam}&fromQueryBuilder=true&type=${
          form?.getFieldValue('qtype') ?? 'A'
        }&window=${
          form?.getFieldValue('window') && form?.getFieldValue('window') !== ''
            ? form?.getFieldValue('window')
            : '30'
        }&origin_uid=${getQueryUID(props?.exploreSchema?.metadata)}`,
      );
    } else if (visualizationType === 'NSChanges') {
      history.push(
        `/explore-result?name=${queryBuilderNameToPassForBreadCrumb
          .replace('[', '')
          .replace(']', '')
          .trim()}&queryType=nschanges&type=A&fromQueryBuilder=true&backLink=${encodeURIComponent(
          window.location.pathname,
        )}${encodeURIComponent(
          window.location.search,
        )}&queryFormEncoded=${formToURLParam}&origin_uid=${getQueryUID(
          props?.exploreSchema?.metadata,
        )}`,
      );
    } else if (visualizationType === 'ssdeep') {
      // encoded query form not included &queryFormEncoded=${formToURLParam}
      history.push(
        `/explore-result?name=${queryBuilderNameToPassForBreadCrumb
          .replace('[', '')
          .replace(']', '')
          .trim()}&queryType=ssdeep&type=ssdeep&fromQueryBuilder=true&backLink=${encodeURIComponent(
          window.location.pathname,
        )}${encodeURIComponent(
          window.location.search,
        )}&originalQueryURL=${encodeURIComponent(finalQueryBuilderURL)}
        
        &origin_uid=${getQueryUID(props?.exploreSchema?.metadata)}`,
      );
    }
  }

  const JSONtoURL = () => {
    let formValues = form.getFieldsValue();
    let arrayOfObjectsForCookieSave = [];

    Object.keys(formValues).map((field, index) =>
      arrayOfObjectsForCookieSave?.push({
        field_name: field,
        field_data: Object.values(formValues)[index],
      }),
    );

    const objectToReturn = btoa(
      JSON.stringify({
        metadata: {
          form_name: nameOfNewQuery,
          form_uuid: selectedSchemaUUID,
          form_description: descriptionOfNewQuery,
          form_parent_uuid:
            props.exploreSchema?.metadata?.form_parent_uuid ||
            selectedSchemaUUID,
        },
        saved_field_data: arrayOfObjectsForCookieSave,
        scope: 'USER',
      }),
    );

    return objectToReturn;
  };

  const handleModalCancel = () => {
    setMonitorModalVisible(false);
    setMonitorName('');
  };

  const handleOk = () => {
    let formValues = form.getFieldsValue();
    let arrayOfObjectsForUpload = [];

    form.validateFields().then(() => {
      Object.keys(formValues).map((field, index) =>
        arrayOfObjectsForUpload?.push({
          field_name: field,
          field_data: Object.values(formValues)[index],
        }),
      );

      props.saveMergeAPIExploreQueryBuilderSchema({
        metadata: {
          form_name: nameOfNewQuery,

          form_description: descriptionOfNewQuery,

          form_parent_uuid:
            props.exploreSchema?.metadata?.form_parent_uuid ||
            selectedSchemaUUID,
        },
        saved_field_data: arrayOfObjectsForUpload,
        scope: 'USER',
      });
      incrementUIRequestsCounter();
    });
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  function deleteQuery() {
    props.deleteMergeAPIExploreQueryBuilderSchema(selectedSchemaUUID);
    setSelectedSchema(null);
    setSelectedSchemaUUID(null);
    cleanup();
    incrementUIRequestsCounter();
  }

  function changeScopeQuery() {
    const schema = props?.exploreSchemas?.form_list?.filter(
      (schema) => schema.form_uuid === selectedSchemaUUID,
    );

    if (schema) {
      props.changeScopeMergeAPIExploreQueryBuilderSchema({
        scope: schema[0]?.scope === 'USER' ? 'ORGANISATION' : 'USER',
        uuid: selectedSchemaUUID,
      });
      incrementUIRequestsCounter();
    }
  }

  function sharingButtonText() {
    const schema = props?.exploreSchemas?.form_list?.filter(
      (schema) => schema?.form_uuid === selectedSchemaUUID,
    );

    if (schema) {
      if (schema[0]?.scope === 'USER') {
        return 'Share';
      } else if (schema[0]?.scope === 'ORGANISATION') {
        return 'Unshare';
      }
    }
  }

  function sharingButtonTooltipText() {
    if (!props.mySubscriptionPlan?.has_access_to_share_unshare) {
      return (
        <>
          Sharing option is not part of this subscription plan. To upgrade your
          subscription contact us at{' '}
          <a target="_blank" href="mailto:sales@silentpush.com">
            sales@silentpush.com
          </a>
          .
        </>
      );
    }

    const schema = props?.exploreSchemas?.form_list?.filter(
      (schema) => schema?.form_uuid === selectedSchemaUUID,
    );

    if (schema) {
      if (schema[0]?.scope === 'USER') {
        return 'Share query with all organization members. This query will be visible to other organization members.';
      } else if (schema[0]?.scope === 'ORGANISATION') {
        return 'Remove access to the query for all organization members. This query will not be visible to all other organization members.';
      }
    }
  }

  function translateFieldTypeToFormField(field) {
    switch (field?.field_format) {
      case 'string':
        if (field?.field_validation?.hasOwnProperty('enum')) {
          return (
            <Radio.Group
              key={field?.field_name}
              name={field?.field_name}
              options={field?.field_validation?.enum}
              defaultValue={field?.field_default}
              optionType="button"
              buttonStyle="solid"
            ></Radio.Group>
          );
        } else if (field?.field_type === 'data_list') {
          return (
            <Input.TextArea rows={6} placeholder="Enter one item per line" />
          );
        } else {
          return <Input maxLength={field?.field_validation?.max_length} />;
        }
      case 'int':
        if (
          field?.field_validation?.hasOwnProperty('enum') &&
          field?.field_validation?.enum[0] == 0
        ) {
          return <Checkbox defaultChecked={field?.field_data === 1} />;
        } else if (
          (field?.field_validation?.hasOwnProperty('enum') &&
            field?.field_validation?.enum[0] != 0) ||
          !field?.field_validation?.range
        ) {
          return <InputNumber />;
        } else if (field?.field_type === 'list') {
          return <Input />;
        } else {
          return (
            <InputNumber
              min={field?.field_validation?.range[0]}
              max={field?.field_validation?.range[1]}
            />
          );
        }
    }
  }

  function getBetween(content) {
    //returns required keys in the URL that are between { } symbols
    if (!content) {
      return [];
    }
    let requiredKeysInURL = content?.match(/[^{\}]+(?=})/g);
    return requiredKeysInURL;
  }

  function checkSavedFields(field) {
    if (field?.field_name === 'job_id' && jobID) {
      return jobID;
    } else if (field?.field_name === 'max_wait' && jobID) {
      return '45';
    }

    if (field?.field_name === 'domain' && q?.get('domain')) {
      return q?.get('domain');
    }

    if (field?.field_name === 'ipv4' && q?.get('ipv4')) {
      return q?.get('ipv4');
    }

    if (field?.field_name === 'infratag' && q?.get('infratag')) {
      return q?.get('infratag');
    }

    if (field?.field_name === 'jarm_hash' && q?.get('jarm_hash')) {
      return q?.get('jarm_hash');
    }

    if (field?.field_name === 'md5' && q?.get('md5')) {
      return q?.get('md5');
    }

    if (field?.field_name === 'mmh3' && q?.get('mmh3')) {
      return q?.get('mmh3');
    }

    if (field?.field_name === 'ssdeep' && q?.get('ssdeep')) {
      return q?.get('ssdeep');
    }

    if (field?.field_name === 'url' && q?.get('url')) {
      return q?.get('url');
    }
    //load saved values from history
    if (history.location.state && resetPressed.current == false) {
      let index = -1;
      index = JSON?.parse(history.location.state)?.saved_field_data?.findIndex(
        (el) => el?.field_name === field?.field_name,
      );
      if (index >= 0) {
        return JSON?.parse(history.location.state)?.saved_field_data[index]
          ?.field_data;
      } else {
        return field?.field_default ? field?.field_default : undefined;
      }
    }

    //else load from the schema
    else {
      let index = -1;
      index = props?.exploreSchema?.saved_field_data?.findIndex(
        (el) => el?.field_name === field?.field_name,
      );
      if (index >= 0) {
        return props?.exploreSchema?.saved_field_data[index]?.field_data;
      } else {
        return field?.field_default ? field?.field_default : undefined;
      }
    }
    // resetPressed.current = false;
  }

  function copyRawData(data) {
    navigator.clipboard.writeText(JSON.stringify(data));
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function copyAPIURL(data) {
    navigator.clipboard.writeText(data);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function validateLimitedAccess() {
    let isExposed = true;
    if (props?.exploreSchemas?.form_list?.length > 0 && selectedSchemaUUID) {
      isExposed = props?.exploreSchemas?.form_list?.filter(
        (schema) => schema.form_uuid === selectedSchemaUUID,
      )?.[0]?.is_exposed;
    } else {
      return false;
    }

    if (props?.mySubscriptionPlan?.has_limited_access_to_query_builder) {
      return isExposed ? true : false;
    } else {
      return true;
    }
  }

  function returnQuerySectionName(name) {
    if (name) {
      let ret = name.split(' ')[0];
      return ret + ' Queries';
    } else return '';
  }

  function getQueryUID(schema) {
    return schema?.form_uuid;
  }

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_query_builder ? (
      <div className={styles.query_builder}>
        <Row gutter={24}>
          <Col xs={24} className={styles.header}>
            {statusLoaded || statusIdle ? (
              <>
                <div className={cx(threat_detail_styles['type-chip'])}>
                  {returnQuerySectionName(
                    props?.exploreSchema?.metadata?.form_name,
                  )}
                </div>

                <div className={styles.queryDescription}>
                  <Paragraph className="m-0">
                    {selectedSchema?.metadata?.form_description
                      ? selectedSchema.metadata.form_description
                      : null}
                  </Paragraph>

                  <RecipeDocumentation
                    queryId={props?.exploreSchema?.metadata?.form_uuid}
                  />
                </div>

                <div className={styles.action_buttons}>
                  {(selectedSchema?.scope === 'USER' ||
                    (selectedSchema?.is_mine === true &&
                      selectedSchema?.scope === 'ORGANISATION')) && (
                    <>
                      <Button
                        danger
                        className={styles.action_button}
                        disabled={statusIdle}
                        onClick={() => deleteQuery(selectedSchemaUUID)}
                      >
                        Delete
                      </Button>
                      <Tooltip title={sharingButtonTooltipText()}>
                        <Button
                          type="link"
                          className={styles.action_button}
                          disabled={
                            statusIdle ||
                            !props.mySubscriptionPlan
                              ?.has_access_to_share_unshare
                          }
                          onClick={() => changeScopeQuery(selectedSchema)}
                        >
                          {sharingButtonText()}
                        </Button>
                      </Tooltip>
                    </>
                  )}
                </div>
              </>
            ) : (
              <LoadingSkeleton />
            )}
          </Col>
        </Row>

        <Form
          form={form}
          name="explore"
          className={styles.query_builder_form}
          initialValues={{}}
          onFinish={(values) => {
            props.clearExploreDetails();
            setBaseURLType(null);
            setQueryBuilderURL(null);
            setDataSource(null);

            form.validateFields().then((values) => {
              incrementUIRequestsCounter();
              Object.entries(values).forEach((key, index) => {
                //check if value is boolean, if it is, convert to int
                if (key[1] === true) {
                  values[key[0]] = '1';
                } else if (key[1] === false) {
                  values[key[0]] = '0';
                }

                //check if value is fingerprint_sha1, and remove empty spaces from it
                if (key?.[0] === 'fingerprint_sha1') {
                  if (key[1]?.length > 0) {
                    values.fingerprint_sha1 = key[1].replace(/\s/g, '');
                  }
                }
              });

              let keysArray = getBetween(
                props?.exploreSchema?.metadata?.form_base_url,
              );
              let newQueryString =
                props?.exploreSchema?.metadata?.form_base_url;
              if (keysArray?.length > 0) {
                //URL building - replace elements in the base URL string that are between {} symbols (keysArray) with values from 'form values'
                keysArray.forEach((key, index) => {
                  newQueryString = newQueryString?.replace(
                    '{' + key + '}',
                    values[key],
                  );
                });
              }

              newQueryString = newQueryString
                ?.replaceAll('{', '')
                ?.replaceAll('}', '');
              let queryURL2 = new URL(newQueryString);
              let params = queryURL2.searchParams;

              for (var key in values) {
                if (values[key]) {
                  if (!keysArray?.includes(key) && values[key] == null) {
                    continue;
                  } else {
                    if (keysArray?.includes(key)) {
                      continue;
                    } else {
                      if (
                        !key?.includes('regex') &&
                        values[key]?.toString()?.includes(';') &&
                        key !== fieldNames[0] &&
                        key !== fieldNames[1]
                      ) {
                        let multipleEntryField = values[key]?.split(';');
                        multipleEntryField.forEach((entry, index) => {
                          params.append(key, entry);
                        });
                      } else {
                        if (key !== fieldNames[0] && key !== fieldNames[1]) {
                          params.append(key, values[key]);
                        }
                      }
                    }
                  }
                }
              }

              //check for ';' separator and dispatch the key into separate values (if not empty after separating)
              let baseURLType = props?.exploreSchema?.metadata?.form_base_url
                .split('/merge-api/')[1]
                ?.split('/')[0];

              newQueryString = queryURL2
                ?.toString()
                ?.split('/merge-api/' + baseURLType)[1];

              newQueryString =
                newQueryString +
                (newQueryString?.includes('?') ? '&' : '?') +
                'origin_uid=' +
                getQueryUID(props?.exploreSchema?.metadata);

              if (baseURLType === 'explore') {
                if (isPostForm === true) {
                  setBaseURLType('explore');
                  props.postMergeAPIExploreDetails({
                    path: decodeURIComponent(newQueryString),
                    [fieldNames[0]]: values[fieldNames[0]]?.trim()?.split('\n'),
                    [fieldNames[1]]: values[fieldNames[1]]?.trim()?.split('\n'),
                    fieldName: fieldNames[0],
                    secondFieldName: fieldNames[1],
                  });
                  setQueryBuilderURL(encodeURIComponent(newQueryString));
                } else {
                  setBaseURLType('explore');
                  props.loadMergeAPIExploreDetails({
                    path: decodeURIComponent(newQueryString),
                  });
                  setQueryBuilderURL(encodeURIComponent(newQueryString));
                }
              } else if (baseURLType === 'merge') {
                if (isPostForm === true) {
                  setBaseURLType('merge');
                  props.postMergeAPIMergeDetails({
                    path: decodeURIComponent(newQueryString),
                    [fieldNames[0]]: values[fieldNames[0]]?.trim()?.split('\n'),
                    [fieldNames[1]]: values[fieldNames[1]]?.trim()?.split('\n'),
                    fieldName: fieldNames[0],
                    secondFieldName: fieldNames[1],
                  });
                  setQueryBuilderURL(encodeURIComponent(newQueryString));
                } else {
                  setBaseURLType('merge');
                  props.loadMergeAPIMergeDetails({
                    path: decodeURIComponent(newQueryString),
                  });
                  setQueryBuilderURL(encodeURIComponent(newQueryString));
                }
              }
            });
          }}
        >
          <Row gutter={24} className={styles.top_actions_row}>
            <Col lg={24} xl={14}>
              {statusLoaded || statusIdle ? (
                <Text strong>
                  <a
                    className={styles.documentation_link}
                    role={'link1'}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={props?.exploreSchema?.metadata?.form_doc_url}
                  >
                    Documentation
                  </a>
                </Text>
              ) : (
                <>
                  <br />
                  <LoadingSkeleton />
                  <br />
                </>
              )}

              {statusLoaded || statusIdle ? (
                <div className={styles.form_control_buttons}>
                  <div className={styles.section_first}>
                    <Radio.Group
                      value={queryBuilderStateFilter}
                      buttonStyle="solid"
                      onChange={(e) => {
                        setQueryBuilderStateFilter(() => e.target.value);
                      }}
                    >
                      <Radio.Button
                        disabled={statusIdle}
                        value="simple"
                        style={
                          queryBuilderStateFilter === 'simple'
                            ? filterButtonChecked
                            : filterButtonUnchecked
                        }
                      >
                        <span>Simple Query</span>
                      </Radio.Button>
                      <Tooltip
                        title={
                          advancedQueryButtonDisabled === true
                            ? `This query doesn't have advanced options.`
                            : ''
                        }
                      >
                        <Radio.Button
                          className={cx({
                            [styles.disabled]: advancedQueryButtonDisabled,
                          })}
                          disabled={statusIdle || advancedQueryButtonDisabled}
                          value="advanced"
                          style={
                            queryBuilderStateFilter === 'advanced'
                              ? filterButtonChecked
                              : filterButtonUnchecked
                          }
                        >
                          <span>Advanced Query</span>
                        </Radio.Button>
                      </Tooltip>
                    </Radio.Group>

                    <Divider
                      className={styles.vertical_divider}
                      type="vertical"
                    />

                    <div>
                      <Tooltip
                        placement="bottom"
                        title={
                          !props?.exploreSchema || !validateLimitedAccess() ? (
                            <>
                              This Advanced Query is not part of this
                              subscription plan. To upgrade your subscription
                              contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          ) : (
                            ''
                          )
                        }
                      >
                        <Button
                          disabled={statusIdle || !validateLimitedAccess()}
                          onClick={() => setIsModalVisible(true)}
                        >
                          {props.exploreSchema?.metadata?.form_parent_uuid
                            ? 'Save As'
                            : 'Save Query'}
                        </Button>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={styles.input_actions}>
                    <Form.Item>
                      <Tooltip
                        placement="bottom"
                        title={
                          !props?.exploreSchema || !validateLimitedAccess() ? (
                            <>
                              This Advanced Query is not part of this
                              subscription plan. To upgrade your subscription
                              contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          ) : (
                            ''
                          )
                        }
                      >
                        <Button
                          disabled={
                            !props?.exploreSchema || !validateLimitedAccess()
                          }
                          role={'button2'}
                          type="primary"
                          htmlType="submit"
                          className="export-form-button"
                        >
                          Search
                        </Button>
                      </Tooltip>
                    </Form.Item>

                    <Form.Item>
                      <Button onClick={() => resetForm()}>Reset Form</Button>
                    </Form.Item>
                  </div>
                </div>
              ) : (
                <LoadingSkeleton />
              )}
            </Col>

            <Col lg={24} xl={10}>
              <div>
                {isVisualizable === true ? (
                  <>
                    <Button
                      className={styles.explore_table_view_button}
                      type="primary"
                      icon={<EyeOutlined />}
                      onClick={() => {
                        visualizeJSONInExplore();
                      }}
                    >
                      Explore Table View
                    </Button>

                    {visualizationType === 'any' ? (
                      <Tooltip
                        title={
                          !props.mySubscriptionPlan
                            ?.has_access_to_monitoring ? (
                            <>
                              Monitoring is not part of this subscription plan.
                              To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          ) : (
                            ''
                          )
                        }
                      >
                        <Button
                          className={styles.monitor_button}
                          type="primary"
                          disabled={
                            !props.mySubscriptionPlan?.has_access_to_monitoring
                          }
                          onClick={() => setMonitorModalVisible(true)}
                        >
                          Monitor
                        </Button>
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </>
                ) : (
                  ''
                )}

                {isJobIDButtonToBeShown &&
                isVisualizable !== true &&
                status === STATUS.LOADED ? (
                  <Button
                    className={styles.jobID_button}
                    type="primary"
                    icon={<FieldTimeOutlined />}
                    onClick={() => {
                      props.loadMergeAPIExploreDetails({
                        path: decodeURIComponent('/job/' + jobID),
                      });
                    }}
                  >
                    Retry JobID
                  </Button>
                ) : (
                  ''
                )}
              </div>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} lg={14}>
              {
                statusLoaded ? (
                  <div className={styles.input_row_container}>
                    {props?.exploreSchema?.field_list
                      ?.filter((element) => {
                        doubleHeightElements = [];
                        return queryBuilderStateFilter === 'advanced'
                          ? element
                          : element.field_hidden === false;
                      })
                      ?.map((field, index) => {
                        if (
                          field?.field_type === 'data_list' ||
                          field?.field_validation?.enum?.join('')?.length > 33
                        ) {
                          doubleHeightElements.push(index);
                        }

                        return (
                          <div className={styles.input_row}>
                            <label>
                              {field.field_label
                                ? field.field_label
                                : field.field_name}
                              {field.field_required ? (
                                <span style={{ color: 'red' }}>*</span>
                              ) : (
                                ''
                              )}

                              <Text>
                                <Popover
                                  placement="right"
                                  content={
                                    <>
                                      <Paragraph style={{ color: 'white' }}>
                                        {field.field_description}
                                      </Paragraph>
                                      <Paragraph
                                        className="m-0"
                                        style={{ color: 'white' }}
                                      >
                                        API parameter: {field.field_name}
                                      </Paragraph>
                                    </>
                                  }
                                >
                                  &nbsp;
                                  <InfoCircleFilled />
                                </Popover>
                              </Text>
                            </label>

                            <Form.Item
                              name={field.field_name}
                              initialValue={checkSavedFields(field)}
                              valuePropName={
                                field?.field_format === 'int' &&
                                field?.field_validation?.hasOwnProperty(
                                  'enum',
                                ) &&
                                field?.field_validation?.enum[0] == 0
                                  ? 'checked'
                                  : 'value'
                              }
                              rules={[
                                {
                                  required: field.field_required,
                                  message: 'This field is required!',
                                },
                                {
                                  pattern:
                                    field?.field_type !== 'list' &&
                                    field?.field_validation?.pattern !== 'regex'
                                      ? new RegExp(/^[^;,]+$/)
                                      : null,
                                  message:
                                    'Multiple entry is not allowed in this field.',
                                },
                              ]}
                            >
                              {translateFieldTypeToFormField(field)}
                            </Form.Item>
                          </div>
                        );
                      })}

                    {props?.exploreSchema?.field_list
                      ?.filter((element) =>
                        queryBuilderStateFilter === 'simple'
                          ? element.field_hidden === true
                          : '',
                      )
                      ?.map((field, index) => (
                        <Form.Item
                          style={{
                            display: 'none',
                          }}
                          name={field.field_name}
                          initialValue={checkSavedFields(field)}
                          rules={[
                            {
                              required: field.field_required,
                              message: 'This field is required!',
                            },
                            {
                              pattern:
                                field.field_type !== 'list'
                                  ? new RegExp(/^[^;,]+$/)
                                  : null,
                              message:
                                'Multiple entry is not allowed in this field.',
                            },
                          ]}
                        >
                          {translateFieldTypeToFormField(field)}
                        </Form.Item>
                      ))}
                  </div>
                ) : (
                  <div className={styles.loading_container}>
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                  </div>
                )
                // ) : (
                //   <p> &#60;&#45; Select a Query Builder schema</p>
                // )
              }
            </Col>

            <Col xs={24} lg={10} className={styles.raw_data_box_column}>
              <Text
                className={cx(styles.info_text, {
                  [styles.visible]: isVisualizable,
                })}
              >
                <InfoCircleFilled /> To save results to a source, click "Explore
                Table View"
              </Text>

              <div className={styles.raw_data_box}>
                <div className={styles.action_buttons}>
                  <Tooltip title="Copy Raw Data">
                    <Button
                      disabled={status !== STATUS.LOADED ? true : false}
                      icon={<CopyOutlined />}
                      onClick={() => {
                        copyRawData(
                          baseURLType === 'merge' ? mergeData : exploreData,
                        );
                      }}
                    >
                      Copy Raw Data
                    </Button>
                  </Tooltip>

                  <Tooltip title="Copy API URL">
                    <Button
                      disabled={baseURLType === null}
                      icon={<CopyOutlined />}
                      onClick={() => {
                        copyAPIURL(
                          baseURLType === 'merge'
                            ? //   q.get('baseURLType') === 'merge'
                              'https://api.silentpush.com/api/v1/merge-api/' +
                                'merge' +
                                decodeURIComponent(queryBuilderURL)
                            : // q.get('queryBuilderURL')
                              'https://api.silentpush.com/api/v1/merge-api/' +
                                'explore' +
                                decodeURIComponent(queryBuilderURL),
                          // q.get('queryBuilderURL'),
                        );
                      }}
                    >
                      Copy API URL
                    </Button>
                  </Tooltip>
                </div>

                <Monitor
                  monitorModalVisible={monitorModalVisible}
                  handleModalCancel={handleModalCancel}
                  origin_uid={getQueryUID(props?.exploreSchema?.metadata)}
                  currentQuery={unescape(queryBuilderURL)}
                  type={baseURLType}
                  websocketConnection={props?.websocketConnection}
                />

                <div className={styles.raw_data}>
                  {status !== STATUS.LOADING ? (
                    dataSource ? (
                      <PrettyPrintJson data={dataSource} />
                    ) : (
                      ''
                    )
                  ) : (
                    <Spin indicator={<LoadingOutlined />} />
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Form>

        <Modal
          title="Save Query"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button
              type="primary"
              disabled={!nameOfNewQuery?.length > 0}
              onClick={handleOk}
            >
              Save
            </Button>,
          ]}
        >
          <label>
            Name<span style={{ color: 'red' }}>* </span>(required)
          </label>
          <Input
            maxLength={40}
            placeholder="Enter Name"
            value={nameOfNewQuery}
            onChange={(event) => setNameOfNewQuery(event.target.value)}
          ></Input>
          <Paragraph style={{ color: 'white' }}>
            {nameOfNewQuery?.length} / 40 characters
          </Paragraph>

          <label>Description</label>
          <Input.TextArea
            rows={5}
            maxLength={3000}
            value={descriptionOfNewQuery}
            placeholder="Enter Description"
            onChange={(event) => setDescriptionOfNewQuery(event.target.value)}
          ></Input.TextArea>
        </Modal>

        <VersionCheck parentComponentStatus={props.schemaStatus} />
      </div>
    ) : (
      <PermissionDeniedPage />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default QueryBuilder;
